import React, { useState } from 'react';
import styles from './CalendarHeaderModal.module.scss';
import { Button } from '@mui/material';
import CalendarCustomizeContent from '../CalendarCustomizeContent';
import { useTranslation } from 'react-i18next';
import {
  COMPACT_CLOSED_DAYS_PARAM,
  HIDE_CLOSED_CHAIRS_PARAM,
  HIDE_TASK_ICONS_PARAM,
  HIDE_TASK_TIME_PARAM,
  isClosureFilterOn,
} from '../../../utils/closureHelpers';

const CalendarHeaderModal = ({
  calendarProps: {
    numberOfActiveDays,
    daySelectedValues,
    calendarWorkers,
    searchParams,
    setSearchParams,
    workerId,
    stepSize,
    setStepSize,
    workTime: {
      startWorkTime,
      endWorkTime,
      setStartWorkTime,
      setEndWorkTime,
    },
  },
  closeModal,
}) => {
  const { t } = useTranslation();
  const [tempNumberOfActiveDays, setTempNumberOfActiveDays] = useState(numberOfActiveDays);
  const [tempActiveWorkerId, setTempActiveWorkerId] = useState(workerId);
  const [tempStepSize, setTempStepSize] = useState(stepSize);
  const [tempStartWorkTime, setTempStartWorkTime] = useState(startWorkTime);
  const [tempEndWorkTime, setTempEndWorkTime] = useState(endWorkTime);
  const [tempHideClosedChairs, setTempHideClosedChairs] = useState(
    isClosureFilterOn(searchParams, HIDE_CLOSED_CHAIRS_PARAM),
  );
  const [tempCompactClosedDays, setTempCompactClosedDays] = useState(
    isClosureFilterOn(searchParams, COMPACT_CLOSED_DAYS_PARAM),
  );
  const [tempShowTaskIcons, setTempShowTaskIcons] = useState(
    !isClosureFilterOn(searchParams, HIDE_TASK_ICONS_PARAM),
  );
  const [tempShowTaskTime, setTempShowTaskTime] = useState(
    !isClosureFilterOn(searchParams, HIDE_TASK_TIME_PARAM),
  );

  const applyWorker = (workerId) => {
    setTempActiveWorkerId(workerId);
    const next = new URLSearchParams(searchParams);
    next.set('activeWorkerId', String(workerId ?? 0));
    setSearchParams(next);
  };

  return (
    <div className={styles.header_modal_container}>
      <div className={styles.header_modal_body}>
        <CalendarCustomizeContent
          calendarWorkers={calendarWorkers}
          activeWorkerId={tempActiveWorkerId}
          onActiveWorkerChange={applyWorker}
          daySelectedValues={daySelectedValues}
          numberOfActiveDays={tempNumberOfActiveDays}
          onNumberOfActiveDaysChange={setTempNumberOfActiveDays}
          stepSize={tempStepSize}
          onStepSizeChange={setTempStepSize}
          startWorkTime={tempStartWorkTime}
          endWorkTime={tempEndWorkTime}
          onStartWorkTimeChange={setTempStartWorkTime}
          onEndWorkTimeChange={setTempEndWorkTime}
          searchParams={searchParams}
          hideClosedChairs={tempHideClosedChairs}
          onHideClosedChairsChange={setTempHideClosedChairs}
          compactClosedDays={tempCompactClosedDays}
          onCompactClosedDaysChange={setTempCompactClosedDays}
          showTaskIcons={tempShowTaskIcons}
          onShowTaskIconsChange={setTempShowTaskIcons}
          showTaskTime={tempShowTaskTime}
          onShowTaskTimeChange={setTempShowTaskTime}
        />
      </div>
      <div className={styles.header_modal_footer}>
        <Button
          className={styles.confirm_button}
          onClick={() => {
            const next = new URLSearchParams(searchParams);
            next.set('activeWorkerId', String(tempActiveWorkerId ?? 0));
            next.set('numberOfActiveDays', String(tempNumberOfActiveDays));
            if (tempHideClosedChairs) next.set(HIDE_CLOSED_CHAIRS_PARAM, '1');
            else next.delete(HIDE_CLOSED_CHAIRS_PARAM);
            if (tempCompactClosedDays) next.set(COMPACT_CLOSED_DAYS_PARAM, '1');
            else next.delete(COMPACT_CLOSED_DAYS_PARAM);
            if (!tempShowTaskIcons) next.set(HIDE_TASK_ICONS_PARAM, '1');
            else next.delete(HIDE_TASK_ICONS_PARAM);
            if (!tempShowTaskTime) next.set(HIDE_TASK_TIME_PARAM, '1');
            else next.delete(HIDE_TASK_TIME_PARAM);
            setSearchParams(next);
            setStepSize(tempStepSize);
            setStartWorkTime(tempStartWorkTime);
            setEndWorkTime(tempEndWorkTime);
            closeModal();
          }}
          variant="contained"
        >
          {t('common.actions.save')}
        </Button>
      </div>
    </div>
  );
};

export default CalendarHeaderModal;
